import { accept, base, createFetch, createStack, header, init, json, method, params } from "http-client";
import Cookies from "js-cookie";
//#region src/api/session.ts
var ResponseError = class extends Error {
	response;
	constructor(message, response) {
		super(message);
		this.response = response;
	}
};
var SessionApi = class {
	BASE_URL = "/api/v1";
	commonStack;
	constructor(cookieKey, railsUrl) {
		this.commonStack = () => createStack(init("credentials", "include"), accept("application/json"), header("Content-Type", "application/json"), header("X-CSRF-Token", Cookies.get(cookieKey)), base(railsUrl));
		Object.getOwnPropertyNames(Object.getPrototypeOf(this)).filter((key) => key !== "constructor").forEach((key) => {
			this[key] = this[key].bind(this);
		});
	}
	doWebGet(url) {
		return createFetch(this.commonStack())(url);
	}
	doWebPost(url, jsonParams) {
		return createFetch(createStack(this.commonStack(), method("POST"), json(jsonParams)))(url);
	}
	doWebPut(url, jsonParams) {
		return createFetch(createStack(this.commonStack(), method("PUT"), json(jsonParams)))(url);
	}
	doWebDelete(url) {
		return createFetch(this.commonStack(), method("DELETE"))(url);
	}
	doWebApiGet(url, getParams) {
		let stack = createStack(this.commonStack());
		if (getParams) stack = createStack(stack, params(getParams));
		return createFetch(stack)(`${this.BASE_URL}${url}`);
	}
	async handleResponse(res) {
		const responseMessage = await res.json();
		if (res.ok) return responseMessage;
		throw new ResponseError(`${res.status} ${res.statusText}` + (responseMessage?.error ? ` ${responseMessage.error}` : ""), responseMessage);
	}
	logIn(email, password, googleIDToken, facebookIDToken) {
		return this.doWebPost("/login", {
			human: {
				email,
				password
			},
			google_id_token: googleIDToken,
			facebook_id_token: facebookIDToken
		}).then(this.handleResponse);
	}
	requestHumanStatus(email) {
		return this.doWebApiGet(`/humans/status?email=${encodeURIComponent(email)}`).then(this.handleResponse);
	}
	requestResetPassword(email) {
		return this.doWebPost(`${this.BASE_URL}/humans/reset-password`, { email });
	}
	register(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl) {
		return this.doWebPost("/register", {
			email,
			full_name: name,
			primary_phone: phone,
			password,
			google_id_token: googleIDToken,
			facebook_id_token: facebookIDToken,
			passwordless_token: passwordlessToken,
			has_generated_password: hasGeneratedPassword,
			redirect_url: redirectUrl
		}).then(this.handleResponse);
	}
	logOut() {
		return this.doWebDelete("/logout");
	}
	fetchSessionInfo() {
		return this.doWebGet("/session/info").then((res) => res.json());
	}
	updateHumanInfo(humanId, password, name, phone) {
		return this.doWebPut(`${this.BASE_URL}/humans/${humanId}`, {
			full_name: name,
			primary_phone: phone,
			current_password: password
		}).then((res) => res.json());
	}
};
//#endregion
export { SessionApi, SessionApi as default };

//# sourceMappingURL=session.mjs.map